import { FormattedMessage } from "react-intl";
import styled from "styled-components";

const TERMS_URL = "https://screencloud.com/terms";
const PRIVACY_URL = "https://screencloud.com/privacy";

const FooterText = styled.p`
  margin: 0;
  max-width: 500px;
  font-family: Lato, sans-serif;
  font-size: 13px;
  line-height: 18px;
  text-align: right;
  color: #474749;
`;

const LegalLink = styled.a`
  color: inherit;
  text-decoration: underline;

  &:hover,
  &:focus-visible {
    color: #19191b;
  }
`;

/**
 * Passive legal agreement shown at the foot of the Payment & Shipping step.
 * Mirrors the billing modal footer (`src/billinglatest/.../Footer`): no consent
 * checkbox, just "by continuing you accept" copy with the Terms of Service and
 * Privacy Policy links opening in a new tab. Self-contained so it can be tested
 * in isolation.
 */
export function LegalFooter() {
  return (
    <FooterText data-testid="payment-shipping-legal-footer">
      <FormattedMessage
        id="pixi_wizard.payment_shipping.legal_footer"
        defaultMessage="By continuing this process, you are accepting our {termsLink} and {privacyLink}."
        values={{
          termsLink: (
            <LegalLink
              href={TERMS_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="payment-shipping-terms-link"
            >
              <FormattedMessage
                id="pixi_wizard.payment_shipping.legal_footer.terms"
                defaultMessage="terms of service"
              />
            </LegalLink>
          ),
          privacyLink: (
            <LegalLink
              href={PRIVACY_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="payment-shipping-privacy-link"
            >
              <FormattedMessage
                id="pixi_wizard.payment_shipping.legal_footer.privacy"
                defaultMessage="privacy policy"
              />
            </LegalLink>
          ),
        }}
      />
    </FooterText>
  );
}
